import { IRootState } from '../../app/store';

export const selectUserAuthenticationStatus = (state: IRootState) =>
    state.login.isUserAuthenticated;
export const selectAuthenticationError = (state: IRootState) =>
    state.login.error;
export const selectAsyncStatus = (state: IRootState) => state.login.asyncStatus;
export const selectFirstName = (state: IRootState) => state.login.firstName;
export const selectLastName = (state: IRootState) => state.login.lastName;
export const selectUserId = (state: IRootState) => state.login.userId;
export const selectId = (state: IRootState) => state.login.id;
export const selectUserEmailId = (state: IRootState) => state.login.email;
export const selectUserPermissions = (state: IRootState) => {
    const permissionDetails =
        (state.login.userRole && state.login.userRole.permissions) || [];
    return permissionDetails.map((permission: any) => permission.name);
};
export const selectOriginalRedirectUrl = (state: IRootState) =>
    state.login.originalRedirectUrl;
export const selectUserRole = (state: IRootState) => state.login.userRole;
export const selectPOCValidAsyncStatus = (state: IRootState) =>
    state.login.pocValidAsyncStatus;
